import { createContext, useContext, useState } from "react";
import { translations } from "../i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("laja-lang") || "en"
  );
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("laja-lang", l);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
